import React from 'react';
import PropTypes from 'prop-types';
import { Switch } from '@headlessui/react';
import './SwitchToggle.css';

const SwitchToggle = ({
  checked,
  onChange,
  label = 'Toggle',
  size = 'md',
  disabled = false,
  className = ''
}) => {
  const normalizedSize = ['sm', 'md', 'lg'].includes(size) ? size : 'md';
  const switchClasses = [
    'switch-toggle',
    `switch-toggle--${normalizedSize}`,
    checked ? 'switch-toggle--on' : 'switch-toggle--off',
    className
  ].filter(Boolean).join(' ');

  const thumbClasses = [
    'switch-toggle-thumb',
    `switch-toggle-thumb--${normalizedSize}`,
    checked ? 'switch-toggle-thumb--on' : 'switch-toggle-thumb--off'
  ].join(' ');

  return (
    <Switch
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      className={switchClasses}
    >
      <span className="sr-only">{label}</span>
      <span className={thumbClasses} aria-hidden="true" />
    </Switch>
  );
};

SwitchToggle.displayName = 'SwitchToggle';

SwitchToggle.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  disabled: PropTypes.bool,
  className: PropTypes.string
};

export default SwitchToggle;
